module.exports = __webpack_public_path__ + "media/cake.db0f283b.mp3";